import React from "react";

export const CourseBundleCircleDesktopIcon = (props) => {
  return (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="49.832"
        cy="49.832"
        r="48.832"
        fill="white"
        stroke="#E4E4E4"
        strokeWidth="2"
      />
      <g clipPath="url(#clip0_6181_40853)">
        <path
          d="M43.5131 76.3886C40.8965 75.7951 38.3835 74.8132 36.0576 73.4756"
          stroke="#18428E"
          strokeWidth="3.66862"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M55.5381 23.6177C61.5149 24.9827 66.8513 28.3365 70.6734 33.13C74.4955 37.9235 76.577 43.8726 76.577 50.0033C76.577 56.1341 74.4955 62.0832 70.6734 66.8767C66.8513 71.6701 61.5149 75.0239 55.5381 76.389"
          stroke="#18428E"
          strokeWidth="3.66862"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.216 65.3156C25.5761 62.9331 24.3306 60.302 23.5273 57.5234"
          stroke="#18428E"
          strokeWidth="3.66862"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.8428 45.4952C23.3238 42.6393 24.2497 39.9337 25.5484 37.4535L26.0564 36.5366"
          stroke="#18428E"
          strokeWidth="3.66862"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34.2148 27.6941C37.0276 25.7578 40.1832 24.3744 43.5131 23.6177"
          stroke="#18428E"
          strokeWidth="3.66862"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M40.5068 50.0042L46.5193 56.0166L58.5442 43.9917"
          stroke="#18428E"
          strokeWidth="3.66862"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6181_40853">
          <rect
            width="72.1494"
            height="72.1494"
            fill="white"
            transform="translate(13.4512 13.9253)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
